<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:20px"
        :model="searchForm" ref="searchForm">
        <el-form-item label="名称：">
          <el-input size="medium" placeholder="名称" v-model="searchForm.ROLE_NAME" clearable @keyup.enter.native="handleSearch()">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" id="search" @click="handleSearch()">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="ROLE_NAME" label="菜单"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-check" @click="match(scope.row)">匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryRoleData, matchRole } from '@/assets/api/accountManage';

export default {
  data() {
    return {
      person_name: sessionStorage.getItem('person_name'),
      client_list: [
        {
          ID: 1,
          name: '用户端',
        },
        {
          ID: 2,
          name: '供应商端',
        },
      ],
      editVisible: false,
      editForm: {},
      loading: false,
      addVisible: false, // 新增模态框
      addForm: {},
      formLabelWidth: '120px',
      tableData: [{}],
      searchForm: {},
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    // 拉取
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SYSTEM_USER_ID: Number(sessionStorage.getItem('SYSTEM_USER_ID')),
        OMS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.ROLE_NAME) {
        params.ROLE_NAME = this.searchForm.ROLE_NAME;
      }
      queryRoleData(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 匹配
    match(row) {
      this.$confirm('确定匹配此功能吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ROLE_ID: row.ID,
          SYSTEM_USER_ID: Number(sessionStorage.getItem('SYSTEM_USER_ID')),
        };
        matchRole(params)
          .then((result) => {
            this.$message.show({ text: '匹配成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消匹配' });
      });
    },
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/operationCenter/matchRole.vue